import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'tgt-textarea',
  standalone: true,
  imports: [NgxMaskDirective, ReactiveFormsModule, NgClass],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
})
export class TextareaComponent {
  isFocused = false;

  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() readonly: boolean = false;
  @Input() linhas: number = 10;
  @Input() placeholder: string = '';
  @Input() error: boolean = false;

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
  }
  // Método que valida o valor
  validarValor() {
    // Sempre que o valor mudar, marca o campo como focado se houver valor
    this.isFocused = !!this.control.value;
  }
}
